import styled from "styled-components";
import { Description as D } from "@evergis/ui";

export const Description = styled(D)`
  margin-top: 1rem;
  margin-bottom: 0;
  text-align: center;

  &:last-of-type {
    margin: 0;
  }
`;
